import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { common, profile } from 'lang/en.json';
import { companySelector, updateAddresses } from 'store/company';
import styles from 'styles/modules/EditAddresses.module.scss';
import AddressSearch from './AddressSearch';
import Button from './Button';
import SidescreenHeader from './Sidescreen/SidescreenHeader';
import Remove from './Svg/Remove';
import Star from './Svg/Star';
import Typo from './Typo';

export default function EditAddresses({ onUpdate, closeFn, title }) {
    const dispatch = useDispatch();
    const { data } = useSelector(companySelector);
    const [addresses, setAddresses] = useState(data.addresses || []);
    const [loading, setLoading] = useState(false);
    const [updated, setUpdated] = useState(false);

    const handleRemove = (keyToRemove) => {
        const tmp = addresses.filter((item, key) => key !== keyToRemove);
        setAddresses([...tmp]);
        setUpdated(true);
    };

    const handleDefault = (keyToDefault) => {
        const tmp = addresses.map((item, key) => {
            return { ...item, ...{ default: key === keyToDefault } };
        });

        setAddresses([...tmp]);
        setUpdated(true);
    };

    const handleConfirm = async () => {
        setLoading(true);
        await dispatch(updateAddresses(addresses));
        setLoading(false);
        setUpdated(false);
        onUpdate();
    };

    let addressesList;

    if (addresses.length > 0) {
        addressesList = addresses.map((item, key) => {
            return (
                <div
                    key={key}
                    className={[
                        'border-gray-bottom',
                        styles.listItem,
                        item.default ? styles.listItemDefault : null,
                    ].join(' ')}
                >
                    <Typo>{item.fullAddress}</Typo>

                    <button
                        className={styles.buttonRemove}
                        onClick={() => handleRemove(key)}
                        title={'Remove address'}
                    >
                        <Remove />
                    </button>

                    {!item.default && (
                        <button
                            className={styles.buttonDefault}
                            onClick={() => handleDefault(key)}
                            title={'Make default address'}
                        >
                            <Star fill={'var(--color-blue)'} />
                        </button>
                    )}

                    {item.default && (
                        <div
                            className={styles.iconDefault}
                            title="Default address"
                        >
                            <Star fill={'#fff'} />
                        </div>
                    )}
                </div>
            );
        });
    } else {
        addressesList = (
            <div className={styles.listItem}>
                <div className={styles.listItemTitle}>
                    {profile.header.address.sidebar.no_address}
                </div>
            </div>
        );
    }

    return (
        <>
            <SidescreenHeader title={title} closeFn={closeFn} />

            <div className={['mb-l', styles.list].join(' ')}>
                {addressesList}
            </div>

            {addresses.length === 0 && (
                <AddressSearch
                    onUpdate={(address) => {
                        address.default = true;
                        const tmp = [...addresses, address];
                        setAddresses(tmp);
                        setUpdated(true);
                    }}
                />
            )}

            <div className={'mt-l'}>
                <Button
                    title={common.save}
                    disabled={!updated}
                    loading={loading}
                    onClick={handleConfirm}
                />
            </div>
        </>
    );
}
